import { IonButtons, IonContent, IonHeader, IonMenuButton, IonModal, IonTitle, IonToolbar } from '@ionic/react'
import { useT } from '@transifex/react'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { customerBackend, customerFrontend } from '../apiConfig'
import { incrementLockIndicator } from '../redux/customerSlice'
import sendToIframe from '../sendToIframe'
import { selectSession } from '../store'

const iframeTitle = 'messages'
export default function MessagesModal({ onDismiss }: { onDismiss: () => void }) {
  const dispatch = useDispatch()
  const t = useT()
  const { authToken, locale } = useSelector(selectSession)
  const [isOpen, setIsOpen] = useState(false)
  useEffect(() => {
    const handler = (event: MessageEvent) => {
      try {
        const { name, route, lockId } = JSON.parse(event.data)

        if (!route.includes(iframeTitle)) return

        if (name === 'loaded' && authToken) {
          sendToIframe(
            {
              name: 'customer',
              authToken,
              backendUrl: customerBackend,
              locale,
            },
            iframeTitle
          )
        }
        if (name === 'showMessages') {
          setIsOpen(true)
        }
        if (name === 'hideMessages') {
          setIsOpen(false)
        }
        if (name === 'accessRequestMessageDismissed') {
          dispatch(incrementLockIndicator(lockId))
        }
      } catch {
        // ignore
      }
    }

    window.addEventListener('message', handler)

    return () => window.removeEventListener('message', handler)
  }, [authToken])

  const iframeSrc = `${customerFrontend}?${iframeTitle}`

  return (
    <IonModal keepContentsMounted isOpen={isOpen} onDidDismiss={onDismiss}>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start"></IonButtons>
          <IonTitle>{t('Messages')}</IonTitle>
          <IonButtons slot="end">
            <IonMenuButton disabled className="text-transparent" />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <iframe title={iframeTitle} src={iframeSrc} width="100%" height="100%" allowFullScreen />
      </IonContent>
    </IonModal>
  )
}
